module.exports = __webpack_public_path__ + "img/banner-law.2597ebb8.png";